enum ViewerCameraTypeEnum {
    Perspective,
    Orthographic
};

export default ViewerCameraTypeEnum;
